const styleManagerKeyToGroup = {
  value: "transform",
  "text-shadow": "text-shadow",
  transition: "transition",
  "box-shadow": "box-shadow",
  background: "background",
};

const PREFIX_GROUP_IDS = ["text-shadow", "transition", "box-shadow"];

const BACKGROUND_KEYS = [
  "background-image",
  "background-repeat",
  "background-position",
  "background-attachment",
  "background-size",
];

const TRANSFORM_FN_KEYS = new Set([
  "scaleX",
  "scaleY",
  "scaleZ",
  "rotateX",
  "rotateY",
  "rotateZ",
  "translateX",
  "translateY",
  "translateZ",
  "skewX",
  "skewY",
  "perspective",
  "matrix",
  "matrix3d",
]);

function nonemptyStyle(elemStyle, key) {
  if (!elemStyle || !key) return false;
  const v = elemStyle[key];
  return v != null && !(typeof v === "string" && v.trim() === "");
}

/** Remove stored row keys for one responsive group (`text-shadow`, `transition`, `box-shadow`, `background`, `transform`). */
function removeRowByGroupId(row, groupId) {
  if (!row || typeof row !== "object" || !groupId) return;

  if (PREFIX_GROUP_IDS.includes(groupId)) {
    const p = `${groupId}-`;
    Object.keys(row).forEach((k) => {
      if (k !== "id" && (k === groupId || k.startsWith(p))) delete row[k];
    });
    return;
  }

  if (groupId === "background") {
    const set = new Set(BACKGROUND_KEYS);
    Object.keys(row).forEach((k) => {
      if (k !== "id" && set.has(k)) delete row[k];
    });
    return;
  }

  if (groupId === "transform") {
    Object.keys(row).forEach((k) => {
      if (k === "id") return;
      if (k === "transform" || k === "value" || k === "name" || k.startsWith("transform-") || TRANSFORM_FN_KEYS.has(k)) {
        delete row[k];
      }
    });
  }
}

export function isResponsiveStyleStoragePropKey(propKey) {
  return propKey != null && Object.prototype.hasOwnProperty.call(styleManagerKeyToGroup, propKey);
}

export function stripResponsiveStyleGroupFromCssRow(row, styleManagerPropKey) {
  const gid = styleManagerKeyToGroup[styleManagerPropKey];
  if (gid) removeRowByGroupId(row, gid);
}

// Merge per-dimension cssObj after load: drop row keys when the component no longer has that style.
export function filterCssObjForPerDimension(elemStyle, row) {
  const { id: _rowId, ...rest } = row;
  const out = { ...rest };

  for (const base of PREFIX_GROUP_IDS) {
    let present = nonemptyStyle(elemStyle, base);
    if (!present) {
      const p = `${base}-`;
      for (const k of Object.keys(elemStyle || {})) {
        if (k.startsWith(p) && nonemptyStyle(elemStyle, k)) {
          present = true;
          break;
        }
      }
    }
    if (!present) removeRowByGroupId(out, base);
  }

  const img = elemStyle?.["background-image"];
  const bgPresent =
    (img != null && String(img).trim() !== "" && String(img).trim() !== "none") ||
    BACKGROUND_KEYS.filter((k) => k !== "background-image").some((k) => nonemptyStyle(elemStyle, k));
  if (!bgPresent) removeRowByGroupId(out, "background");

  const t = elemStyle?.transform;
  const transformPresent = t != null && String(t).trim() !== "" && String(t).trim() !== "none";
  if (!transformPresent) removeRowByGroupId(out, "transform");

  return out;
}
